export default "__VITE_ASSET__3a655aa1__"